import syncFields from '../_syncfields.js';
import reportModified from '../_reportmodified.js';
import toMatreshkaArray from '../_tomatreshkaarray.js';
import apply from '../../_helpers/apply.js';
import assign from '../../_helpers/assign.js';
import withLengthOptions from '../_withlengthoptions.js';
import toAbsoluteIndex from '../_toabsoluteindex.js';
import { spliceStart } from '../_processrendering/processspliceadd.js';
import checkAddedItems from '../_processrendering/checkbeforechange.js';
var slice = Array.prototype.slice;
// creates splice or splice_ method and returns it
// TODO: Improve readability of createSplice function
export default function createSplice(hasOptions) {
  return function pseudoNativeMethod() {
    var _this = this;
    var selfDef = syncFields(this);
    var itemMediator = selfDef.itemMediator;
    var functionArguments = arguments;
    var argsLength = Math.max(functionArguments.length - +hasOptions, 0);
    var args = Array(argsLength);
    var givenEventOptions = hasOptions ? functionArguments[functionArguments.length - 1] : null;
    var useMediator = typeof itemMediator === 'function' && !(givenEventOptions != null && givenEventOptions.skipItemMediator);
    var added = [];
    var length = this.length;
    var start = toAbsoluteIndex(functionArguments[0], length);
    // convert arguments to array and call item mediator on every new item if it's possible
    for (var i = 0; i < argsLength; i++) {
      var arg = functionArguments[i];
      if (i < 2) {
        args[i] = arg;
      } else {
        args[i] = useMediator ? itemMediator(arg, start + (i - 2)) : arg;
        added[i - 2] = args[i];
      }
    }
    if (added.length) {
      // the items this splice removes keep their nodes
      checkAddedItems(this, selfDef, added, givenEventOptions, slice.call(this, start, start + +args[1]));
    }
    // call original method
    // TODO: Change array manually in splice method for better performance
    var returns = withLengthOptions(this, givenEventOptions, function () {
      return apply(Array.prototype.splice, _this, args);
    });
    // removed items mean returned items
    var removed = returns;
    // if something is added or removed
    if (added.length || removed.length) {
      var eventOptions = {
        added: added,
        removed: removed,
        method: 'splice',
        self: this
      };
      eventOptions[spliceStart] = start;
      // extend event options by custom event options if they are given
      if (hasOptions) {
        if (givenEventOptions && typeof givenEventOptions === 'object') {
          assign(eventOptions, givenEventOptions);
        }
      }
      reportModified(this, eventOptions);
    }
    return toMatreshkaArray(returns);
  };
}